<template>
    <el-dialog :title="`[${viewData.sourceName}] ${viewData.name}${viewData.phone}`" :visible.sync="show"
        width="550px">
        <el-table :data="viewData.timelines" border fit highlight-current-row style="width: 100%" max-height="350">
            <el-table-column align="left" label="时间" width="150">
                <template slot-scope="scope">
                    <span>
                        {{ parseTime(scope.row.createdAt, "{y}-{m}-{d} {h}:{i}") }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="结果">
                <template slot-scope="scope">
                    <span>
                        <el-row v-for="column in tableColumns" :key="column.prop">
                            <template v-if="scope.row[column.prop] != ''">
                                <el-col :span="5">{{ column.label }}</el-col>
                                <el-col :span="19">{{ scope.row[column.prop] }}</el-col>
                            </template>
                        </el-row>
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button @click="show = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { parseTime } from '@/utils/index'
export default {
    name: 'timeline',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        viewData: {
            type: Object,
            default: () => ({ timelines: [] })
        },
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        },
        show(newVal) {
            this.$emit('update:visible', newVal);
        },
    },
    data() {
        return {
            parseTime,
            show: false,
            tableColumns: [
                { prop: 'handleOwnerName', label: '处理人员:' },
                { prop: 'result', label: '处理结果:' },
                { prop: 'followOwnerName', label: '客户经理:' },
                { prop: 'remark', label: '备注:' }
            ]
        }
    },
    methods: {
    }
}
</script>